
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Layout extends Vue {
  @Prop({ type: Boolean, default: true }) readonly sidebarOpen!: boolean;
}
